(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[261],{

/***/ 7406:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "e": function() { return /* binding */ UpButton; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(9499);
// EXTERNAL MODULE: ./node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(917);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./lib/consts.ts
var consts = __webpack_require__(9006);
;// CONCATENATED MODULE: ./public/img/arrow.svg
var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var SvgArrow = function SvgArrow(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.456 18.797a1.125 1.125 0 0 0 1.593 0l5.953-5.956 5.954 5.956a1.127 1.127 0 0 0 1.593-1.594l-6.75-6.75a1.124 1.124 0 0 0-1.593 0l-6.75 6.75a1.124 1.124 0 0 0 0 1.594Z"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 25.875a1.125 1.125 0 0 0 1.125-1.125V13.5a1.125 1.125 0 1 0-2.25 0v11.25A1.125 1.125 0 0 0 18 25.875Z"
  })));
};
/* harmony default export */ var arrow = (SvgArrow);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(5944);
;// CONCATENATED MODULE: ./components/common/UpButton.tsx






function UpButton(_ref) {
  var elementId = _ref.elementId,
      _ref$screenCount = _ref.screenCount,
      screenCount = _ref$screenCount === void 0 ? 1 : _ref$screenCount,
      _ref$mobileScreenCoun = _ref.mobileScreenCount,
      mobileScreenCount = _ref$mobileScreenCoun === void 0 ? 2 : _ref$mobileScreenCoun;

  var _useState = (0,react.useState)(false),
      showButton = _useState[0],
      setShowButton = _useState[1];

  var scrollUp = function scrollUp() {
    window.scrollTo(0, 0);
  };

  var checkScroll = function checkScroll() {
    var isMobile = window.innerWidth < consts/* DEVICE_SCREENS.md */.XA.md;
    var screenHeight = document.documentElement.clientHeight;
    var isShowButton = false;

    if (isMobile) {
      isShowButton = window.scrollY > mobileScreenCount * window.innerHeight;
    } else {
      var element = elementId ? document.getElementById(elementId) : null;
      isShowButton = element ? element.getBoundingClientRect().top <= 100 : window.scrollY > screenCount * screenHeight;
    }

    setShowButton(isShowButton);
  };

  (0,react.useEffect)(function () {
    window.addEventListener('scroll', checkScroll);
    return function () {
      window.removeEventListener('scroll', checkScroll);
    };
  }, []);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("div", {
    children: showButton && (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("button", {
      css: /*#__PURE__*/(0,emotion_react_browser_esm/* css */.iv)((0,defineProperty/* default */.Z)({
        width: 42,
        height: 42,
        borderRadius: '100%',
        border: '3px solid #F44336',
        position: 'fixed',
        bottom: '10%',
        right: '10%',
        background: '#fff',
        zIndex: 100,
        cursor: 'pointer',
        svg: {
          fill: '#F44336'
        },
        ':hover': {
          background: '#DA3226',
          borderColor: '#DA3226',
          opacity: 0.7,
          svg: {
            fill: '#fff'
          }
        },
        ':active': {
          background: '#C61A0D',
          borderColor: '#C61A0D',
          opacity: 0.7,
          svg: {
            fill: '#fff'
          }
        }
      }, consts/* DEVICE_SCREENS_MAX_STRING.md */.fD.md, {
        right: 8,
        bottom: 60
      }),  true ? "" : 0,  true ? "" : 0),
      type: "button",
      onClick: scrollUp,
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(arrow, {})
    })
  });
}

/***/ }),

/***/ 193:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "aI": function() { return /* binding */ ACTION_TYPES; },
/* harmony export */   "jL": function() { return /* binding */ CATEGORIES_STATUS; },
/* harmony export */   "x5": function() { return /* binding */ RESERVATION_TYPES; }
/* harmony export */ });
/* unused harmony exports QUOTA_REMAINDER_TYPES, actionFormFieldsNames */
var CATEGORIES_STATUS = {
  OPEN: 'OPEN',
  CLOSE_VISIBLE: 'CLOSE_VISIBLE',
  CLOSE_HIDDEN: 'CLOSE_HIDDEN'
};
var ACTION_TYPES = {
  certificate: 'certificate',
  purchase: 'purchase',
  reservation: 'reservation',
  FREE: 'FREE',
  partner_widget: 'partner_widget',
  astra_marine: 'astra_marine',
  tsnext_widget: 'tsnext_widget'
};
var RESERVATION_TYPES = {
  full: 'full',
  shortened: 'shortened'
};
var QUOTA_REMAINDER_TYPES = {
  unlimited: 'unlimited',
  noTickets: 'noTickets',
  remainderCount: 'remainderCount'
};
var actionFormFieldsNames = {
  first_name: 'name',
  last_name: 'surname',
  phone_number: 'phone',
  email: 'mail',
  date: 'date',
  time: 'date_time',
  count: 'count'
};

/***/ }),

/***/ 923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "A": function() { return /* binding */ getBuyButtonText; },
/* harmony export */   "Bz": function() { return /* binding */ isEventPassed; },
/* harmony export */   "Gc": function() { return /* binding */ useSendMetricsFromButton; },
/* harmony export */   "Qi": function() { return /* binding */ hasOwnPolyfill; },
/* harmony export */   "Qw": function() { return /* binding */ getCancellationPolicyText; }
/* harmony export */ });
/* unused harmony export MaxNumberReservationsAtATime */
/* harmony import */ var luxon__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(120);
/* harmony import */ var _models_action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(193);
/* harmony import */ var _constants_events__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6880);
/* harmony import */ var _providers_seo_analytics__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5165);





var checkPassedWithTime = function checkPassedWithTime(now, endDate) {
  for (var i = 0; i < endDate.time.length; i += 1) {
    var date = luxon__WEBPACK_IMPORTED_MODULE_0__/* .DateTime.fromFormat */ .ou.fromFormat("".concat(endDate.end_date, " ").concat(endDate.time[i]), 'yyyy-LL-dd HH:mm:ss').valueOf();

    if (now < date) {
      return false;
    }
  }

  return true;
};

var getCancellationPolicyText = function getCancellationPolicyText(cancellationPolicy) {
  switch (cancellationPolicy) {
    case 'free_cancel':
      return 'бесплатная отмена и возврат средств за 72 часа до мероприятия';

    case '10_days':
      return 'отмена билетов и возврат средств: более 10 дней – 100% стоимости билета, менее 10 дней, но более 5 дней – 50%, менее 5 дней, но более 3 дней – 30%, менее 3 дней – возврат денежных средств не производится';

    default:
      return 'возврат билетов, приобретенных со скидкой, не осуществляется';
  }
};
var isEventPassed = function isEventPassed(action) {
  var _action$dates;

  var now = new Date().getTime();
  var eventPassed = true;
  if (!(action !== null && action !== void 0 && (_action$dates = action.dates) !== null && _action$dates !== void 0 && _action$dates.length)) return eventPassed;

  for (var i = 0; i < action.dates.length; i += 1) {
    var endDate = action.dates[i];
    var date = new Date(endDate.end_date).getTime();

    if (now > date && endDate.time.length) {
      eventPassed = checkPassedWithTime(now, endDate);
    } else {
      eventPassed = now > new Date("".concat(endDate.end_date, " 23:59:59")).getTime();
    }

    if (!eventPassed) break;
  }

  return eventPassed;
};
var MaxNumberReservationsAtATime = 20;
var useSendMetricsFromButton = function useSendMetricsFromButton() {
  var seoAnalytics = (0,_providers_seo_analytics__WEBPACK_IMPORTED_MODULE_3__/* .useSeoAnalytics */ .$)();

  var onSend = function onSend(item, isRanOutOfTickets) {
    // 'Подписка оформлена';
    if (item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .activeStatus */ .cT && item.subscription_confirmed) {
      return;
    } // 'Подписаться на уведомления';


    if (item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .activeStatus */ .cT && isRanOutOfTickets) {
      return;
    } // 'У события неактивный статус'


    if (item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .archiveStatus */ .ME || item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .closeStatus */ .xp || item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .inactiveStatus */ .mv) {
      return;
    }

    if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.reservation */ .aI.reservation && item.reservation_type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .RESERVATION_TYPES.shortened */ .x5.shortened) {
      // 'Оставить заявку'
      seoAnalytics.dispatch({
        ym: ['Click_request']
      });
      return;
    }

    if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.FREE */ .aI.FREE) {
      // 'Посетить бесплатно'
      seoAnalytics.dispatch({
        ym: ['Click_free']
      });
      return;
    }

    if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.reservation */ .aI.reservation) {
      // 'Забронировать со скидкой || Забронировать'
      if (!item.discount) {
        seoAnalytics.dispatch({
          ym: ['Click_book']
        });
        return;
      }

      seoAnalytics.dispatch({
        ym: ['Click_book_sale']
      });
      return;
    }

    if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.partner_widget */ .aI.partner_widget) {
      // Партнерский виджет
      seoAnalytics.dispatch({
        ym: ['widget_buy']
      });
      return;
    } // 'Купить со скидкой || Купить'


    if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.certificate */ .aI.certificate) {
      if (!item.discount) {
        seoAnalytics.dispatch({
          ym: ['Click_buy']
        });
        return;
      }

      seoAnalytics.dispatch({
        ym: ['Click_buy_sale']
      });
      return;
    } // 'Купить со скидкой || Купить' (смартбилет)


    if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.purchase */ .aI.purchase) {
      if (!item.discount) {
        seoAnalytics.dispatch({
          ym: ['Click_buy_smart']
        });
        return;
      }

      seoAnalytics.dispatch({
        ym: ['Click_buy_sale_smart']
      });
      return;
    } // Новый виджет от гб


    if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.tsnext_widget */ .aI.tsnext_widget) {
      seoAnalytics.dispatch({
        ym: ['Click_new_biletka']
      });
      return;
    }

    seoAnalytics.dispatch({
      ym: ['Click_buy']
    });
  };

  return {
    onSend: onSend
  };
};
function getBuyButtonText(item) {
  var isRanOutOfTickets = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var isFromV4Data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  if (item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .activeStatus */ .cT && item.subscription_confirmed) {
    return 'Подписка оформлена';
  }

  if (item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .activeStatus */ .cT && isRanOutOfTickets) {
    return 'Подписаться на уведомления';
  }

  if (item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .activeStatus */ .cT && item.not_season) {
    return 'Подписаться на событие';
  }

  if (item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .archiveStatus */ .ME || item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .closeStatus */ .xp || item.status === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .inactiveStatus */ .mv) {
    if (item.archiving_reason) {
      if (item.archiving_reason === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .archivingReason.eventPassed */ .SL.eventPassed) {
        return 'Событие состоялось';
      }

      if (item.archiving_reason === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .archivingReason.eventCanceled */ .SL.eventCanceled) {
        return 'Событие отменено';
      }

      if (item.archiving_reason === _constants_events__WEBPACK_IMPORTED_MODULE_2__/* .archivingReason.ticketsOver */ .SL.ticketsOver) {
        return 'Закончились билеты/места';
      }
    } else {
      return 'Акция завершена';
    }
  }

  if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.reservation */ .aI.reservation && item.reservation_type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .RESERVATION_TYPES.shortened */ .x5.shortened) {
    return 'Оставить заявку';
  }

  if (isFromV4Data && !item.has_further_dates) {
    return 'Событие состоялось';
  }

  if (!isFromV4Data && isEventPassed(item) && !item.date_unknown) {
    return 'Событие состоялось';
  }

  if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.FREE */ .aI.FREE) {
    return 'Посетить бесплатно';
  }

  if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.reservation */ .aI.reservation) {
    return "\u0417\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u0442\u044C".concat(item.discount ? ' со скидкой' : '');
  }

  if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.partner_widget */ .aI.partner_widget) {
    return item.purchase_button ? item.purchase_button : 'Купить';
  }

  if (item.type === _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.tsnext_widget */ .aI.tsnext_widget) {
    return item.purchase_button ? item.purchase_button : 'Купить';
  }

  if ([_models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.certificate */ .aI.certificate, _models_action__WEBPACK_IMPORTED_MODULE_1__/* .ACTION_TYPES.purchase */ .aI.purchase].includes(item.type)) {
    return "\u041A\u0443\u043F\u0438\u0442\u044C".concat(item.discount ? ' со скидкой' : '');
  }

  return 'Купить';
}
var hasOwnPolyfill = function hasOwnPolyfill(obj, property) {
  if (Object.hasOwn) {
    return Object.hasOwn(obj, property);
  } // eslint-disable-next-line no-prototype-builtins


  return obj.hasOwnProperty(property);
};

/***/ }),

/***/ 6703:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 3751:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,t){ true?module.exports=t(__webpack_require__(7294)):0}("undefined"!=typeof self?self:this,(e=>(()=>{"use strict";var t={156:t=>{t.exports=e}},r={};function o(e){var n=r[e];if(void 0!==n)return n.exports;var s=r[e]={exports:{}};return t[e](s,s.exports,o),s.exports}o.d=(e,t)=>{for(var r in t)o.o(t,r)&&!o.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},o.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),o.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var n={};return(()=>{o.r(n),o.d(n,{default:()=>l,useStopwatch:()=>u,useTime:()=>m,useTimer:()=>c});var e=o(156);class t{static expiryTimestamp(e){const t=new Date(e).getTime()>0;return t||console.warn("react-timer-hook: { useTimer } Invalid expiryTimestamp settings",e),t}static onExpire(e){const t=e&&"function"==typeof e;return e&&!t&&console.warn("react-timer-hook: { useTimer } Invalid onExpire settings function",e),t}}class r{static getTimeFromSeconds(e){const t=Math.ceil(e),r=Math.floor(t/86400),o=Math.floor(t%86400/3600),n=Math.floor(t%3600/60);return{totalSeconds:t,seconds:Math.floor(t%60),minutes:n,hours:o,days:r}}static getSecondsFromExpiry(e,t){const r=e-(new Date).getTime();if(r>0){const e=r/1e3;return t?Math.round(e):e}return 0}static getSecondsFromPrevTime(e,t){const r=(new Date).getTime()-e;if(r>0){const e=r/1e3;return t?Math.round(e):e}return 0}static getSecondsFromTimeNow(){const e=new Date;return e.getTime()/1e3-60*e.getTimezoneOffset()}static getFormattedTimeFromSeconds(e,t){const{seconds:o,minutes:n,hours:s}=r.getTimeFromSeconds(e);let i="",a=s;return"12-hour"===t&&(i=s>=12?"pm":"am",a=s%12),{seconds:o,minutes:n,hours:a,ampm:i}}}function s(t,r){const o=(0,e.useRef)();(0,e.useEffect)((()=>{o.current=t})),(0,e.useEffect)((()=>{if(!r)return()=>{};const e=setInterval((()=>{o.current&&o.current()}),r);return()=>clearInterval(e)}),[r])}const i=1e3;function a(e){if(!t.expiryTimestamp(e))return null;const o=r.getSecondsFromExpiry(e),n=Math.floor(1e3*(o-Math.floor(o)));return n>0?n:i}function c(){let{expiryTimestamp:o,onExpire:n,autoStart:c=!0}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const[u,m]=(0,e.useState)(o),[l,d]=(0,e.useState)(r.getSecondsFromExpiry(u)),[p,f]=(0,e.useState)(c),[g,S]=(0,e.useState)(c),[T,y]=(0,e.useState)(a(u)),h=(0,e.useCallback)((()=>{t.onExpire(n)&&n(),f(!1),y(null)}),[n]),x=(0,e.useCallback)((()=>{f(!1)}),[]),v=(0,e.useCallback)((function(e){let t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];y(a(e)),S(t),f(t),m(e),d(r.getSecondsFromExpiry(e))}),[]),F=(0,e.useCallback)((()=>{const e=new Date;e.setMilliseconds(e.getMilliseconds()+1e3*l),v(e)}),[l,v]),b=(0,e.useCallback)((()=>{g?(d(r.getSecondsFromExpiry(u)),f(!0)):F()}),[u,g,F]);return s((()=>{T!==i&&y(i);const e=r.getSecondsFromExpiry(u);d(e),e<=0&&h()}),p?T:null),{...r.getTimeFromSeconds(l),start:b,pause:x,resume:F,restart:v,isRunning:p}}function u(){let{autoStart:t,offsetTimestamp:o}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const[n,i]=(0,e.useState)(r.getSecondsFromExpiry(o,!0)||0),[a,c]=(0,e.useState)(new Date),[u,m]=(0,e.useState)(n+r.getSecondsFromPrevTime(a||0,!0)),[l,d]=(0,e.useState)(t);s((()=>{m(n+r.getSecondsFromPrevTime(a,!0))}),l?1e3:null);const p=(0,e.useCallback)((()=>{const e=new Date;c(e),d(!0),m(n+r.getSecondsFromPrevTime(e,!0))}),[n]),f=(0,e.useCallback)((()=>{i(u),d(!1)}),[u]),g=(0,e.useCallback)((function(){let e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:0,t=!(arguments.length>1&&void 0!==arguments[1])||arguments[1];const o=r.getSecondsFromExpiry(e,!0)||0,n=new Date;c(n),i(o),d(t),m(o+r.getSecondsFromPrevTime(n,!0))}),[]);return{...r.getTimeFromSeconds(u),start:p,pause:f,reset:g,isRunning:l}}function m(){let{format:t}=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{};const[o,n]=(0,e.useState)(r.getSecondsFromTimeNow());return s((()=>{n(r.getSecondsFromTimeNow())}),1e3),{...r.getFormattedTimeFromSeconds(o,t)}}function l(t){if((0,e.useEffect)((()=>{console.warn("react-timer-hook: default export useTimer is deprecated, use named exports { useTimer, useStopwatch, useTime } instead")}),[]),t.expiryTimestamp){const e=c(t);return{...e,startTimer:e.start,stopTimer:e.pause,resetTimer:()=>{}}}const r=u(t);return{...r,startTimer:r.start,stopTimer:r.pause,resetTimer:r.reset}}})(),n})()));

/***/ }),

/***/ 1383:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _taggedTemplateLiteral; }
/* harmony export */ });
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

/***/ })

}]);